/* eslint-disable max-len */

import React from 'react';

export const Flag = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flag-01">
        <path
          id="Icon"
          d="M2.33334 8.75033C2.33334 8.75033 2.91668 8.16699 4.66668 8.16699C6.41668 8.16699 7.58334 9.33366 9.33334 9.33366C11.0833 9.33366 11.6667 8.75033 11.6667 8.75033V1.75033C11.6667 1.75033 11.0833 2.33366 9.33334 2.33366C7.58334 2.33366 6.41668 1.16699 4.66668 1.16699C2.91668 1.16699 2.33334 1.75033 2.33334 1.75033L2.33334 12.8337"
          stroke="#101828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
